import { Client,Account,Databases,Storage } from 'appwrite';
const client = new Client()
    .setEndpoint('https://cloud.appwrite.io/v1') 
    .setProject('66098019dd541f15e34c');

export const account = new Account(client);
export const databases = new Databases(client);
export const storage = new Storage(client);
export default client;